import React from 'react'

export function UpArrow(props: any) {
  return (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 47.255 47.255"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M46.255 35.941a.997.997 0 01-.707-.293l-21.921-21.92-21.92 21.92a.999.999 0 11-1.414-1.414L22.92 11.607a.999.999 0 011.414 0l22.627 22.627a.999.999 0 01-.706 1.707z" />
    </svg>
  )
}
